import React from "react";
import { cn } from "../../../lib/helpers";

export const ProgressBar = ({
  step, totalSteps = 5, className
}) => (
  <div className={cn("flex-grow flex items-center", className)}>
    <div className="w-full bg-light-5 rounded-full h-4">
      <div
        className="bg-light-10 h-4 rounded-full transition-all duration-300"
        style={{ width: `${(step / totalSteps) * 100}%` }}
      />
    </div>
    <p className="text text-gray-400 text-center mb-2">
      &nbsp;
    </p>
    <p className="text-light-30 text-center font-superhero font-medium text-2xl italic whitespace-nowrap ml-2">
      {step} of {totalSteps}
    </p>
  </div>
);